module.exports = __webpack_public_path__ + "img/img2.816f5126.jpg";